import styled from 'styled-components';
import shadow from '../../assets/images/jail_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	position: absolute;
	bottom: 20px;
	right: 30px;
	z-index: 10;
	width: 300px;
	overflow: hidden;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 20px 20px 25px 20px;
	transform: translateX(350px);
	transition:
		opacity 0.3s ease,
		transform 0.3s ease;

	&.jail-info-enter {
		opacity: 0;
		transform: translateX(350px);
	}

	&.jail-info-enter-active,
	&.jail-info-enter-done,
	&.jail-info-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.jail-info-exit-active {
		transform: translateX(350px);
		opacity: 0;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -200px;
	right: -250px;
	width: 400px;
	height: 400px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledTopContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 14px 64px;
	gap: 10px;
	align-items: center;
`;

export { StyledContainer, StyledShadow, StyledTopContainer };
